import React from 'react'
import DescriptionSkill from '../../descriptionSkill/descriptionSkill'

export default function CareerSkillDescription({careerSkillData}) {
  return (
    <DescriptionSkill textDesscription={'มีทักษะ'} data={careerSkillData} />
  )
}
